<template>
    <span class="icon" v-bind="$attrs" :aria-hidden="false" aria-label="Light" role="img" @click="$emit('click', $event)">
        <svg :width="size" :height="size" viewBox="0 0 448 512">
            <path d="M448 209.91a210.06 210.06 0 0 1-122.77-39.25v178.72A162.55 162.55 0 1 1 185 188.31v89.89a74.62 74.62 0 1 0 52.23 71.18V0h88a121.18 121.18 0 0 0 1.86 22.17A122.18 122.18 0 0 0 381 102.39a121.43 121.43 0 0 0 67 20.14z" :fill="fillColor"></path>
        </svg>
    </span>
</template>

<script lang="ts" setup>
interface Props {
    fillColor?: string;
    size?: number;
}
defineEmits(['click'])
withDefaults(defineProps<Props>(), {
    fillColor: 'currentColor',
    size: 16
})
</script>